import React from 'react';
import _ from 'lodash';

import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemText,
  styled,
  Typography
} from '@mui/material';

import { LabelledText } from 'modules';



const SectionTypography = styled(Typography)(({ theme }) => ({
  marginLeft: theme.spacing(3),
  marginTop: theme.spacing(1)
}));

const DrawerBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2)
}));

const LineItemContainerBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch'
});

const QtyTypography = styled(Typography)({
  textAlign: 'right'
});



export interface IOrderLite {
  id: string;
  orderNumber: string;
  customerFullName: string;
  customerEmail: string;
  lineItems: ILineItemLite[];
}

export interface ILineItemLite {
  id: string;
  productName: string;
  sku: string;
  quantity: number;
}

export interface IProps {
  order: IOrderLite;
}

export const FC: React.FC<IProps> = props => {
  return (
    <>
      <SectionTypography
        variant="h2">
        {props.order.orderNumber}
      </SectionTypography>

      <Divider />

      <DrawerBox>
        <LabelledText.FC
          title="Full Name"
          text={props.order.customerFullName ?? ""} />

        <LabelledText.FC
          title="Email"
          text={props.order.customerEmail ?? ""} />
      </DrawerBox>

      <LineItemContainerBox>
        <SectionTypography variant="h2">
          Products
        </SectionTypography>

        <Divider />

        <DrawerBox>
          <QtyTypography>
            Qty
          </QtyTypography>

          <List>
            {_.map(props.order.lineItems ?? [], lineItem => (
              <ListItem
                key={lineItem.id}
                secondaryAction={(
                  <Typography>
                    {lineItem.quantity}
                  </Typography>
                )}>
                <ListItemText
                  primary={lineItem.productName}
                  secondary={lineItem.sku}>
                </ListItemText>
              </ListItem>
            ))}
          </List>
        </DrawerBox>
      </LineItemContainerBox>
    </>
  );
};
